var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 28,
    height: 25.163,
    fill: "#74613c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11111",
    "data-name": "Group 11111",
    transform: "translate(-154 -301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    transform: "translate(154 301)",
    fill: "none",
    stroke: "#74613c",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 33.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11110",
    "data-name": "Group 11110",
    transform: "translate(175 323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11109",
    "data-name": "Group 11109",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M164.125,11.454a2.917,2.917,0,0,0-2.917-2.917h-7.363a.292.292,0,0,1-.291-.292l.015-.09a10.141,10.141,0,0,0,.607-5.142C153.489.569,152.036-.137,150.9.02a2.333,2.333,0,0,0-1.94,2.391c0,3.2-2.484,6.7-4.707,8.238a.585.585,0,0,0-.252.481v11.8a.584.584,0,0,0,.472.573c.417.08.795.157,1.152.232a20.148,20.148,0,0,0,4.793.55H158c2.283,0,2.625-1.283,2.625-2.042a2.615,2.615,0,0,0-.271-1.159,2.623,2.623,0,0,0,1.167-3.5,2.628,2.628,0,0,0,1.437-2.342,2.6,2.6,0,0,0-.318-1.25,2.917,2.917,0,0,0,1.485-2.541",
    transform: "translate(-136.125 0)",
    fill: "#74613c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M6.125,183.944a1.167,1.167,0,0,0-1.167-1.167H1.167A1.167,1.167,0,0,0,0,183.944v12.834a1.167,1.167,0,0,0,1.167,1.167H4.958a1.167,1.167,0,0,0,1.167-1.167Zm-1.75,10.792a.875.875,0,1,1-.875-.875.875.875,0,0,1,.875.875",
    transform: "translate(0 -172.781)",
    fill: "#74613c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8d7fca4836fe03ed01deafcbc2cf01fd.svg";
export { ForwardRef as ReactComponent };